import ApiClient from '../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new ApiClient();

export const useGetAnnouncements = (isAuthenticated: boolean) => {
    return useQuery({
        queryKey: ['get-announcements'],
        queryFn: async () => {
            const response = await _apiClient.getAnnouncements();

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve Announcements.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        enabled: isAuthenticated,
    });
};
